import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskJourneyConfigurationRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-journey-configuration',
	path: '/jira/servicedesk/projects/:projectKey/settings/journeys/:journeyId',
	exact: true,
};
